<template>
    <div class="iconManage">
        <div class="breadcrumb"> 入口ICON管理
            <el-button class="right_f" type="primary" @click="newIcon()">新增</el-button>
        </div>
        <!-- 状态下拉框 -->
        <div class="search">
            <el-select v-model="status" @change="getList">
                <el-option label="全部" value='0'></el-option>
                <el-option label="草稿" value='1'></el-option>
                <el-option label="待上线" value='2'></el-option>
                <el-option label="已上线" value='3'></el-option>
                <el-option label="过期" value='4'></el-option>
            </el-select>
        </div>

        <div class="com-list">
            <!-- 入口ICON列表 -->
            <el-table :data="list" style="overflow-x: auto;">
                <el-table-column type="index" label="序号" align='center' width="80">
                </el-table-column>
                <el-table-column prop="description" label="广告说明" align='center'>
                </el-table-column>
                <el-table-column prop="applicableCampus" label="适用学校" align='center' width="120">
                </el-table-column>
                <el-table-column prop="showtime" label="展示时间" align='center'>
                </el-table-column>
                <el-table-column prop="state" label="状态" align='center' width="80">
                </el-table-column>
                <el-table-column prop="latestdo" label="最近操作记录" align='center' width="200">
                </el-table-column>
                <el-table-column inline-template label="操作">
                    <span>
                        <el-button class="option" type="text" @click="newIcon(row.id)" v-if="row.state=='草稿'">编辑</el-button>
                        <el-button class="option" type="text" @click="deleteIcon(row)">删除</el-button>
                    </span>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <div class="pagination">
            <el-pagination v-show="totalCount" layout="prev, pager, next, jumper" :page-size="pageSize" :current-page="currentPage" :total="totalCount"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                status: "0",
                pageSize: 20,
                operatorId: "",
                list: [],
                totalCount: 0,
                currentPage: 1
            }
        },
        mounted() {
            this.operatorId = this.$store.state.user.userId;
            // 进入页面求情入口ICON列表；
            this.getList();
        },
        methods: {
            //获取入口Icon列表
            getList() {
                let url = this.$util.domain + '/api/v1/module/main/list';
                //根据当前下拉框状态发送请求列表的ajax；
                this.$http({
                    url,
                    method: 'POST',
                    body: JSON.stringify({
                        pageNum: this.currentPage,
                        pageSize: this.pageSize,
                        state: this.status * 1
                    })
                }).then((response) => {
                    //请求成功，重置icon列表数组；
                    this.list = [];
                    if (response.data.error === 10000) {
                        let dataList = response.data.data.list;
                        this.totalCount = response.data.data.total;

                        //对请求数据进行遍历格式化，并赋值给icon列表数组；
                        this.handleData(dataList);
                    } else {
                        this.$util.errorMsg(response.data.message);
                    }
                });
            },
            //数据处理
            handleData(dataList) {
                if (dataList && dataList.length > 0) {
                    for (let i = 0; i < dataList.length; i++) {
                        let description = dataList[i].description,
                            applicableCampus = dataList[i].applicableCampus == 0 ? '全部' : '部分',
                            startTime = new Date(dataList[i].startTime).format('yyyy/MM/dd hh:00'),
                            endTime = new Date(dataList[i].endTime).format('yyyy/MM/dd hh:00'),
                            lastOperateTime = new Date(dataList[i].lastOperateTime).format('yyyy/MM/dd hh:mm'),
                            lastOperator = dataList[i].lastOperator,
                            id = dataList[i].id,
                            state = dataList[i].state;

                        switch (state) {
                            case 1:
                                state = '草稿'
                                break;
                            case 2:
                                state = '待上线'
                                break;
                            case 3:
                                state = '已上线'
                                break;
                            default:
                                state = '过期'
                                break;
                        }

                        this.list.push({
                            description,
                            applicableCampus,
                            state,
                            id,
                            showtime: startTime + ' - ' + endTime,
                            latestdo: lastOperator + '  ' + lastOperateTime
                        })
                    }
                }
            },
            //分页回调
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList();
            },
            //跳转新增和编辑页
            newIcon(id) {
                if (id) {
                    location.href = "/#/yunying/icon/newIcon?id=" + id;
                } else {
                    location.href = "/#/yunying/icon/newIcon";
                }
            },
            //删除入口ICon
            deleteIcon(row) {
                //弹出确认是否删除Icon弹出框
                this.$confirm(`是否要删除 ${row.description}  的入口icon`, '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    //选择确定，发送ajax请求，删除icon;
                    let url = this.$util.domain + '/api/v1/module/main/del';

                    this.$http({
                        url,
                        method: 'GET',
                        params: {
                            id: row.id * 1,
                            operatorId: this.operatorId * 1
                        }
                    }).then(response => {
                        if (response.data.error === 10000) {
                            this.$util.successMsg("删除成功");
                            this.getList();
                        } else {
                            this.$util.errorMsg(response.data.message);
                        }
                    }).catch(response => {
                        //选择否，关闭弹框；
                    })
                })
            }
        },

    }
</script>

<style>
    .iconManage .el-input {
        display: inline-block;
    }

    .iconManage .el-button {
        display: inline-block;
    }

    .iconManage .el-button+.el-button {
        margin-left: 0;
    }

    .iconManage .search {
        margin-bottom: 20px;
    }

    .iconManage .el-select {
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// iconManage.vue?2037cca6